import { useStyleConfig } from '@chakra-ui/react';
import { Props, Select } from 'chakra-react-select';

export type SearchableSelectProps = { showNoDropDown?: boolean } & Props;
export const SearchableSelect = ({
  showNoDropDown,
  ...rest
}: SearchableSelectProps) => {
  const styles: any = useStyleConfig('Select');

  return (
    <Select
      {...rest}
      chakraStyles={{
        control: (provided) => ({
          ...provided,
          ...styles.field,
        }),
        placeholder: (provided) => ({
          ...provided,
          color: 'brand.monochromatic.300',
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? 'blue.500' : 'transparent',
          px: '48px',
          _hover: {
            backgroundColor: 'blue.500',
            color: 'white',
          },
        }),
        loadingIndicator: (provided) => ({
          ...provided,
          color: 'blue.500',
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          ...styles.icon,
          ...(showNoDropDown && { display: 'none' }),
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          borderColor: styles.icon.borderColor,
          ...(showNoDropDown && { display: 'none' }),
        }),
      }}
    />
  );
};
